export class ServicePaymentInvoice {
	service: string
    paymentsValue: number
    invoicesValue: number
	vatValue: number
}